//@flow
import Box from "@mui/material/Box";
import React, { useContext, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import AlertForCatalogLock from "../../../../../components/app/alertForCatalogLock/alertForCatalogLock";
import { TabPanel } from "../../../../../components/general/tabPanel/tabPanel";
import { exhibitorMenu } from "../../../../../helpers/menu/menu";
import useExhibitionData from "../../../../../hooks/exhibitions/useExhibitionData";
import { useExhibitor } from "../../../../../hooks/exhibitions/useExhibitor";
import useMenuAction from "../../../../../hooks/menu/useMenuAction";
import useQueryParams from "../../../../../hooks/useQueryParams";
import { EXHIBITOR_PROFILE } from "../../../../../locales/components/namespaces";
import { TitleContext } from "../../../../main/content";
import ExhibitorProfile from "../../../../profileExhibitor/profileExhibitor";
import Details from "../../common/details/details";

const Main = () => {
	const { t } = useTranslation(EXHIBITOR_PROFILE)
	const { setMenuItems } = useMenuAction()
	const queryParams = useQueryParams()
	const section = queryParams.get('section') ?? ""
	const { id } = useParams()
	const { byId: exhibition, loading } = useExhibitionData({ id })
	const { setMenuNavigation } = useContext(TitleContext)
	const { exhibitor } = useExhibitor({
		language: 'any',
		overrideExhibitorId: 'currentUser',
		section: ""
	})
	// Το μενού του εκθέτη σχετίζεται με την έκθεση, δεν είναι γενικό. Οπότε φτιάχνεται μετά την επιλογή έκθεσης.
	useEffect(() => {
		setMenuItems({
			items: [...exhibitorMenu({
				t: t,
				hasExhibitorScanning: exhibition.hasExhibitorScanning && exhibitor?.hasExhibitorScanning,
				id: id,
				displayServiceProvidersToExhibitor: exhibition.displayServiceProvidersToExhibitor,
				displayContractorsToExhibitor: exhibition.displayContractorsToExhibitor,
				displayPartnersToExhibitor: exhibition.displayPartnersToExhibitor,
				displayExhibitorKitAndAddsToExhibitor: exhibition.displayExhibitorKitAndAddsToExhibitor,
				displayVisitorsToExhibitor: exhibition.displayVisitorsToExhibitor,
				displayFreeAdvertisementToExhibitor: exhibition.displayFreeAdvertisementToExhibitor
			})]
		})
		return () => {
			setMenuItems({ items: [] })
		}
	}, [id, setMenuNavigation, exhibition.buttonColor, t, exhibition.displayVisitorsToExhibitor, exhibition.displayExhibitorKitAndAddsToExhibitor, exhibition.displayPartnersToExhibitor, exhibition.displayServiceProvidersToExhibitor, exhibition.displayContractorsToExhibitor, setMenuItems, exhibition.hasExhibitorScanning, exhibitor?.hasExhibitorScanning, exhibition.displayFreeAdvertisementToExhibitor])
	
	return (
		<Box>
			{exhibitor && exhibition && !loading && (
				<AlertForCatalogLock
					exhibition={exhibition}
					exhibitor={exhibitor}
				/>
			)}
			<TabPanel isVisible={section === ""} sx={{ pt: 2 }}>
				<Details
					exhibition={exhibition}
					loading={loading}
				/>
			</TabPanel>
			<TabPanel isVisible={section === "profile"}>
				<Box sx={{ my: 1.5 }}/>
				<ExhibitorProfile
					id={"currentUser"}
				/>
			</TabPanel>
		</Box>
	)
}

export default Main